// extracted by mini-css-extract-plugin
export default {"main":"KT5AIV","container":"kTZ2bn","mobile":"U2O3Kv","title":"bQQJeZ","text":"WKQpf7","link":"YSmAd4"};